import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from '@mui/material';
export const DurationDay = ({ duration }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: 'subtitle1', children: "Duration:" }), _jsxs(Typography, { variant: 'subtitle1', fontWeight: 'bold', children: [duration, " ", duration === 1 ? 'day' : 'days'] })] }));
};
